import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { CouponApplicationType } from '@shared/models/Enums';

import { envVariables } from "@shared/mock-data";
import { Constants } from '@shared/shared.constants';
import { ApiTransactionService } from '@services/api-transaction.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-assigned-givi-modal',
    templateUrl: './assigned-givi-modal.component.html',
    styleUrls: ['./assigned-givi-modal.component.scss']
})
export class AssignedGiviModalComponent implements OnInit {

    @ViewChild('assignedModal', { static: true }) assignedModal: TemplateRef<any>;
    @Input() productImage: string = '';
    @Input() isCoupon: boolean = false;
    @Input() points: number;
    @Input() couponApplicationType: CouponApplicationType = CouponApplicationType.General;

    openLink = '';

    viewNumber = 1; //1 = boom, 2 = go to app

    constructor(public modalService: NgbModal,
        public router: Router,
        private apiTransactionService: ApiTransactionService) { }  

    ngOnInit(): void {

        this.apiTransactionService.getEnvVariables().then(()=>{
            this.openLink = envVariables[Constants.ENV_GIVIAPP_OPEN_LINK_VALUE_KEY] ?? null;
        })

        /* this.modalService.open(this.assignedModal, {
            backdrop: 'static', keyboard: false, scrollable: true,
            centered: true
        }); */
    }

    onNextView(){
        this.viewNumber = 2;
    }

    openGivi() {
        
        this.modalService.dismissAll();
        this.router.navigate([`/market`], { queryParams: { loadAccount: 1, login: 'success' } })
        //window.open(this.openLink);
    }

    openGiviWeb() {

        window.open("https://migivi.com/givis");
    }

}
